import { Strong } from "../Reusables/Typography/P";

const LargerHeading = ({children}) => (
    <Strong
        className="f-medium"
    >
        {children}
    </Strong>
)

export default LargerHeading;